import BenchlingConfig from 'BenchlingConfig';

export default function staticURL(path: string): string {
  const sanitizedPath = path.replace(/^\//, ''); // Strip leading slash
  const baseURL = BenchlingConfig.CDN_DOMAIN ? `//${BenchlingConfig.CDN_DOMAIN}` : '';
  return `${baseURL}/${sanitizedPath}`;
}
